import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faHome,
    faComments,
    faHistory,
    faCog,
    faChartBar,
    faInbox,
    faBell,
    faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import axios from "axios";
import Constants from "./Constants";
import type { NotificationRecord } from "../types/api";

const MenuContainer = styled.div`
    width: 80px;
    height: 100vh;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0;
    border-right: 1px solid #e0e0e0;
`;

const MenuItem = styled(Link)<{ $active?: boolean }>`
    margin: 1rem 0;
    width: 40px;
    height: 40px;
    background-color: ${({ $active }) => ($active ? '#007bff' : '#fff')};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    text-decoration: none;
    position: relative;

    &:hover {
        background-color: #e0e0e0;
    }
`;


const LogoutItem = styled.div`
    margin: 1rem 0;
    margin-top: auto;
    width: 40px;
    height: 40px;
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    &:hover {
        background-color: #e0e0e0;
    }
`;

const CounterItem = styled.div`
    position: absolute;
    top: -5px;
    right: -5px;
    background: red;
    color: white;
    font-weight: bold;
    min-width: 16px;
    height: 16px;
    border-radius: 50%;
    text-align: center;
    font-size: 10px;
    line-height: 16px;
    padding: 0 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.3);
`;

interface LeftMenuProps {
    onLoginSuccess: (token: string | boolean | false) => void;
}

const LeftMenu = ({ onLoginSuccess }: LeftMenuProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [counter, setCounter] = useState(0);

    const handleLogout = () => {
        // Example: Clear auth token from localStorage
        // localStorage.removeItem('authToken');
        // Navigate to login page
        onLoginSuccess(false)
        localStorage.removeItem("authToken");
        navigate('/login');
    };
    useEffect(() => {
        let timeoutId: ReturnType<typeof setTimeout> | undefined;
        const fetchRecords = async () => {
            try {
                const response = await axios.get(Constants.serverlink + '/notification?owner=casino');
                if (response.status === 200) {
                    const unread = (response.data as NotificationRecord[]).filter(
                        (x) => !x.read
                    );
                    setCounter(unread.length);
                }
            } catch (error: unknown) {
                // 404 means no notifications — reset badge to 0
                const axiosErr = error as { response?: { status?: number } };
                if (axiosErr.response?.status === 404) {
                    setCounter(0);
                } else {
                    console.error('Error fetching notifications:', error);
                }
            } finally {
                // always keep polling, even on error
                timeoutId = setTimeout(fetchRecords, 4000);
            }
        };

        fetchRecords();
        return () => clearTimeout(timeoutId);
    }, []);
    return (
        <MenuContainer>
            <MenuItem to="/history" $active={location.pathname === '/history'}>
                <FontAwesomeIcon icon={faComments} color={location.pathname === '/history' ? "#fff" : "#333"} />
            </MenuItem>
            <MenuItem to="/analytics" $active={location.pathname === '/analytics'}>
                <FontAwesomeIcon icon={faChartBar} color={location.pathname === '/analytics' ? "#fff" : "#333"} />
            </MenuItem>
            <MenuItem to="/reservations" $active={location.pathname === '/reservations'} title="Reservations">
                <FontAwesomeIcon icon={faInbox} color={location.pathname === '/reservations' ? "#fff" : "#333"} />
            </MenuItem>

            <MenuItem to="/notification" $active={location.pathname === '/notification'}>
                {counter>0 &&<CounterItem>{counter}</CounterItem>}
                <FontAwesomeIcon icon={faBell} color={location.pathname === '/notification' ? "#fff" : "#333"} />
            </MenuItem>

            <LogoutItem onClick={handleLogout} role="button" tabIndex={0}>
                <FontAwesomeIcon icon={faSignOutAlt} color="#333" />
            </LogoutItem>
        </MenuContainer>
    );
};

export default LeftMenu;
